import store from '../store'
import { hasPermission, hasAnyPermission, isSuperAdmin } from '@/helpers/permissions'

export default async (to, from, next) => {
  // document.title = `${to.name} - Series Wished`

  if (to.name !== 'login' && to.name !== 'sso' && !store.getters['auth/hasToken']) {
    try {
      await store.dispatch('auth/ActionCheckToken')
      next({ path: to.path })
    } catch (err) {
      next({ name: 'login' })
    }
  } else {
    if (to.name === 'login' && store.getters['auth/hasToken']) {
      next({ name: 'home' })
    } else {
      // Check route permissions
      if (to.meta && to.meta.permission) {
        // Check if user is super admin (has all permissions)
        if (isSuperAdmin()) {
          next()
          return
        }

        // Check single permission
        if (typeof to.meta.permission === 'string') {
          if (!hasPermission(to.meta.permission)) {
            next({ name: 'home' })
            return
          }
        }

        // Check array of permissions (user needs any of them)
        if (Array.isArray(to.meta.permission)) {
          if (!hasAnyPermission(to.meta.permission)) {
            next({ name: 'home' })
            return
          }
        }
      }

      next()
    }
  }
}
